module.exports = __webpack_public_path__ + "img/cs-basicEduS-6.e9d0ea80.jpg";